export interface GroupInterface {
  grpId: string;
  name: string;
  status: string;
  type: string;
  orgId: string;
  creatorName?: string;
  avatar?: string;
  typeLabel?: string;
  description?: string;
  buildState?: Record<string, any>;
  creator?: {
    id?: string;
    name?: string;
    headshot?: string;
  };
  createdBy?: string;
  // ATC: active seconds the admin spent building this program (BE-accumulated,
  // clamped, stops at Invited). Insights V3 reads this one for Time-To-Completion.
  aimdBuildSeconds?: number;
  // ATC as Amplitude reports it: the same counter frozen at the "Create" click.
  // Null on programs created before the freeze shipped.
  aimdCreateSeconds?: number | null;
}

export interface AdminProgramItem {
  id: string;
  name: string;
  type: string;
  status: string;
  createdBy?: string;
  creator?: {
    id?: string;
    name?: string;
    headshot?: string;
  };
  buildState?: {
    description?: string;
  };
  // ATC: BE-accumulated active build seconds (see GroupInterface.aimdBuildSeconds).
  aimdBuildSeconds?: number;
  aimdCreateSeconds?: number | null;
}

export interface UserProgramInfo {
  id: string;
  name: string;
  type: string;
  roles: string[];
  progress?: number;
  etaText?: string;
  status?: string;
  objectivesPending?: number;
  menteesEngaged?: number;
  messagesSent?: number;
  meetingsScheduled?: number;
  onClick?: () => void;
  loading?: boolean;
  orgId?: string;
  grpId?: string;
  buildState?: Record<string, any>;
}

export type ColumnStatus = 'design' | 'published' | 'invited' | 'active';

export const STATUS_COLUMNS: { key: ColumnStatus; label: string }[] = [
  { key: 'design', label: 'Design' },
  { key: 'published', label: 'Published' },
  { key: 'invited', label: 'Enrolled' },
  { key: 'active', label: 'Active' }
];

export const STATUS_TOOLTIPS: Record<ColumnStatus, string> = {
  design: 'Programs still in progress, not yet ready to launch.',
  published: 'Programs that are complete but have no enrolled members yet.',
  invited: 'Programs with at least one enrolled member.',
  active: 'Programs with at least one completed lesson or arranged match.'
};

export const STATUS_TOOLTIP_SX = {
  background: 'var(--Fill-tooltip-dim, #2A2A2A)',
  padding: '10px 14px',
  borderRadius: '6px',
  outline: '1px solid var(--Stroke-Border-border, #444444)',
  outlineOffset: '-1px',
  maxWidth: 320,
  display: 'inline-flex',
  flexDirection: 'column',
  gap: '6px',
  alignItems: 'flex-start',
  justifyContent: 'flex-start'
} as const;

export const STATUS_TOOLTIP_TEXT_SX = {
  width: '100%',
  maxWidth: 320,
  color: 'var(--Text-text-primary, #FDFDFD)',
  fontSize: 12,
  fontWeight: 600,
  fontFamily: 'Inter',
  lineHeight: '16px'
} as const;

export const APP_HEADER_HEIGHT = 84;

// Hidden in production — internal/test orgs that should never surface.
export const HIDDEN_GROUP_IDS = new Set(['6972a4fbfb6041ae60d9abff', '69de9099a4172ad01306947b']);
